import React from "react";

/**
 * AddressComponent
 * @param {Object} props
 * @param {Object} props.address - Address object with fields: id, full_name, is_default, country, city, street, building, zip, state, phone
 * @param {boolean} [props.selected] - Whether this address is selected (for radio button)
 * @param {function} [props.onSelect] - Callback when address is selected
 */
const AddressComponent = ({ address, selected = false, onSelect }) => {
  if (!address) return null;

  return (
    <div
      className="address-inner ui-card-outer bg-white p-2 p-sm-3 d-flex align-items-start justify-content-start"
      style={{ minWidth: 100, maxWidth: 180, direction: "rtl", border: "1px solid #e0e0e0" }}
    >
      <input
                className="form-check-input me-2"
                type="radio"
                aria-label="Radio button for selecting address"
                name="address"
                checked={selected}
                onChange={() => onSelect && onSelect(address.id)}
                style={{ accentColor: "var(--bs-first)", width: 20, height: 20, marginTop: 0 }}
            />
      <div className="flex-grow-1">
        <div className="fw-bold mb-1">
          {address.country} - {address.city}
        </div>
        <div className="text-muted" style={{ wordBreak: "break-word" }}>
          {address.building}، {address.street}
        </div>
      </div>

    </div>
  );
};

export default AddressComponent;
